import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign, FolderKanban, FileText, TrendingUp } from 'lucide-react';
import type { Client } from '@/types/entities';

interface ClientStatsProps {
  client: Client;
}

export function ClientStats({ client }: ClientStatsProps) {
  const stats = [
    {
      label: 'Total Revenue',
      value: `$${client.totalRevenue.toLocaleString()}`,
      icon: DollarSign,
      iconBgColor: 'bg-green-100',
      iconColor: 'text-green-600',
    },
    {
      label: 'Active Projects',
      value: client.activeProjects.toString(),
      icon: FolderKanban,
      iconBgColor: 'bg-blue-100',
      iconColor: 'text-blue-600',
    },
    {
      label: 'Total Projects',
      value: client.totalProjects.toString(),
      icon: FileText,
      iconBgColor: 'bg-purple-100',
      iconColor: 'text-purple-600',
    },
    {
      label: 'Client Status',
      value: client.status.charAt(0).toUpperCase() + client.status.slice(1),
      icon: TrendingUp,
      iconBgColor: 'bg-orange-100',
      iconColor: 'text-orange-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <Card key={index}>
            <CardHeader className="flex flex-row items-center justify-between pb-2 space-y-0">
              <CardTitle className="text-sm font-medium text-gray-600">
                {stat.label}
              </CardTitle>
              <div className={`p-2 rounded-lg ${stat.iconBgColor}`}>
                <Icon className={`h-4 w-4 ${stat.iconColor}`} />
              </div>
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
